<template>
  <div class="mc-dashboard__widget-item">
    <div class="mc-dashboard__widget-header d-flex justify-content-between">
      <div>
        <h4 class="font-size-16 teal-400 mb-1">
          {{ $t('dashboard.chart.totalDrivingDuration') }}
        </h4>
        <p class="font-size-10 teal-400 mb-0">
          {{ monthsPeriod }}
        </p>
      </div>
    </div>
    <div class="mc-dashboard__widget-content">
      <b-skeleton-wrapper :loading="localLoading">
        <template #loading>
          <b-row>
            <b-col md="12">
              <b-skeleton width="100%" height="350px" />
            </b-col>
          </b-row>
        </template>
        <div v-if="!refresh" class="mc-chart">
          <LineChart
            :labels="totalChartData.minutes.labels"
            :datasets="totalChartData.minutes.datasets"
            :yLabel="$t('dashboard.chart.totalDuration')"
          />
        </div>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/Line'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    LineChart,
  },

  mixins: [Helper],

  props: {
    loading: {
      type: Boolean,
    },
    tripsStatistics: {
      type: Object,
    },
    period: {},
  },

  data() {
    return {
      isLayoutEdit: false,
      refresh: false,
      months: [],
      localLoading: this.loading,
      drivingDuration: [],
      monthsPeriod: '',
    }
  },

  computed: {
    totalChartData() {
      return {
        minutes: {
          labels: this.months,
          datasets: [
            {
              data: this.drivingDuration,
              label:
                this.$t('dashboard.chart.totalDrivingDuration') +
                ` (${this.$t('global.time.minutes')})`,
              backgroundColor: '#e7f2ee',
              borderColor: '#137c55',
            },
          ],
        },
      }
    },
  },

  watch: {
    tripsStatistics: {
      handler(newVal) {
        if (newVal?.data?.length) {
          this.prepareChartData()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (this.tripsStatistics?.data?.length) {
      this.prepareChartData()
    }
  },

  methods: {
    prepareChartData() {
      this.localLoading = true
      this.months = this.tripsStatistics?.data.map((item) => this.localizeMonth(item.month))
      this.drivingDuration = this.tripsStatistics?.data.map((item) =>
        parseFloat(item.engineOnDuration.chosenValue / 60).toFixed(2)
      )
      this.refresh = true

      const months = this.tripsStatistics?.data.map(
        (item) => `${this.localizeMonth(item.month)} ${item.year}`
      )
      this.monthsPeriod = `${months[0]} - ${months[2]}`

      setTimeout(() => {
        this.refresh = false
        this.localLoading = false
      }, 800)
    },
  },
}
</script>
